(() => {
  const config = document.currentScript?.dataset || {};
  const reactions = new Set(['Love', 'Wow', 'Angry', 'Haha', 'Sad', 'Care']);
  function facebookUrl(value) {
    try {
      const url = new URL(String(value || '').trim());
      const host = url.hostname.toLowerCase();
      return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password &&
        (host === 'facebook.com' || host.endsWith('.facebook.com') || host === 'fb.watch') &&
        url.pathname.replace(/\//g, '').length > 0;
    } catch (_) {
      return false;
    }
  }
  function followerUrl(value) {
    const raw = String(value || '').trim();
    if (!/^https:\/\/(www|m)\.facebook\.com\/[^\s\\]+$/.test(raw)) return false;
    try {
      const url = new URL(raw);
      return url.protocol === 'https:' && ['www.facebook.com', 'm.facebook.com'].includes(url.hostname) &&
        !url.username && !url.password && !url.port && url.pathname.replace(/\//g, '').length > 0;
    } catch (_) {
      return false;
    }
  }
  function scopeFor(form) {
    if (!(form instanceof HTMLFormElement)) return null;
    return form.closest('[data-fb-reactions], [data-fb-followers]') ||
      (form.getAttribute('id') === 'service-atc-form' ? document.querySelector('product-form[data-fb-reactions], product-form[data-fb-followers]') : null);
  }
  function showError(field, message) {
    field.setCustomValidity(message);
    field.setAttribute('aria-invalid', 'true');
    const errorId = field.id + '-fb-error';
    let error = document.getElementById(errorId);
    if (!error) {
      error = document.createElement('p');
      error.id = errorId;
      error.className = 'text-sm mt-2';
      error.style.color = '#b91c1c';
      error.setAttribute('role', 'alert');
      field.parentElement.appendChild(error);
    }
    error.textContent = message;
    error.hidden = false;
    const descriptions = new Set((field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
    descriptions.add(errorId);
    field.setAttribute('aria-describedby', [...descriptions].join(' '));
  }
  function clearError(field) {
    field.setCustomValidity('');
    field.removeAttribute('aria-invalid');
    const error = document.getElementById(field.id + '-fb-error');
    if (error) error.hidden = true;
  }
  function validateForm(form) {
    const scope = scopeFor(form);
    if (!scope) return true;
    const fields = Array.from(form.elements);
    if (scope.hasAttribute('data-fb-followers')) {
      const link = fields.find(field => field.matches('[data-fb-followers-link]'));
      if (!link) return false;
      link.value = link.value.trim();
      clearError(link);
      if (!followerUrl(link.value)) {
        showError(link, config.invalidFollowerLink);
        link.focus();
        link.reportValidity();
        return false;
      }
      return form.reportValidity();
    }
    const link = fields.find(field => field.matches('[data-fb-link]'));
    const reaction = fields.find(field => field.matches('[data-fb-reaction]'));
    if (!link || !reaction) return false;
    link.value = link.value.trim();
    clearError(link);
    clearError(reaction);
    let firstInvalid = null;
    if (!facebookUrl(link.value)) {
      showError(link, config.invalidLink);
      firstInvalid = link;
    }
    if (!reactions.has(reaction.value)) {
      showError(reaction, config.missingReaction);
      firstInvalid ||= reaction;
    }
    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.reportValidity();
      return false;
    }
    return form.reportValidity();
  }
  function preventInvalid(event, form) {
    if (!validateForm(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button[type="submit"], input[type="submit"]');
    if (button?.form) preventInvalid(event, button.form);
  }, true);
  document.addEventListener('submit', event => preventInvalid(event, event.target), true);
  document.addEventListener('invalid', event => {
    const field = event.target;
    if (field.matches('[data-fb-followers-link]')) showError(field, config.invalidFollowerLink);
    if (field.matches('[data-fb-link]')) showError(field, config.invalidLink);
    if (field.matches('[data-fb-reaction]')) showError(field, config.missingReaction);
  }, true);
  for (const type of ['input', 'change']) {
    document.addEventListener(type, event => {
      if (event.target.matches('[data-fb-link], [data-fb-reaction], [data-fb-followers-link]')) clearError(event.target);
    });
  }
  window.ifFacebookReactions = { validateForm, facebookUrl, followerUrl };
})();

